import {
  MOOD_JOURNAL_GET_JOURNALS_BEGINS,
  MOOD_JOURNAL_GET_JOURNALS_FAILURE,
  MOOD_JOURNAL_GET_JOURNALS_SUCCESS,
  MOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
} from './constants';
import { List } from 'immutable';
import fetchJournals from '../services/MoodJournalService';

export const getJournals = ({ userId, startDate, endDate, timezone, coachRole }) => {
  return dispatch => {
    dispatch({
      type: MOOD_JOURNAL_GET_JOURNALS_BEGINS,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = fetchJournals({ userId, startDate, endDate, timezone, coachRole });

      doRequest.then(
        res => {
          dispatch({
            type: MOOD_JOURNAL_GET_JOURNALS_SUCCESS,
            data: {
              listing: res.listing,
            },
          });
          resolve(res);
        },
        error => {
          dispatch({
            type: MOOD_JOURNAL_GET_JOURNALS_FAILURE,
            data: {
              error,
            },
          });
          reject(error);
        },
      );
    });

    return promise;
  };
};

export function dismissGetJournalsError() {
  return {
    type: MOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MOOD_JOURNAL_GET_JOURNALS_BEGINS:
      return {
        ...state,
        lisiting: List(),
        getJournalsPending: true,
        getJournalsError: null,
      };

    case MOOD_JOURNAL_GET_JOURNALS_SUCCESS:
      return {
        ...state,
        listing: state.listing.withMutations(journal =>
          action.data.listing.map(d => {
            const isExist = journal.find(n => n.id === d.id);
            return !isExist ? journal.push(d) : null;
          }),
        ),
      };

    case MOOD_JOURNAL_GET_JOURNALS_FAILURE:
      return {
        ...state,
        getJournals: false,
        getJournalsError: action.data.error,
      };

    case MOOD_JOURNAL_GET_JOURNALS_DISMISS_ERROR:
      return {
        ...state,
        getJournalsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/mood-journal/redux/getJournals.js